
<template>


  <body>
  <div class="wrapper" >
    <div class="topBackground"></div>
    <div class="activeTitle">
      <h2>领航计划初心使命</h2>
      <p>保险经纪人是一个专业的身份，这是一个超级个体的时代，每个超级个体需要是专业身份才能进行的职业态。在保险行业内，个人认为举个例子：保险经纪人就像是医生，而保险代理就像是药店销售。获得身份只是第一步，还需要丰富的案例库（服务案例，产品情况），需要服务中标资质（比如大客户招投标都需要审核资质）。而这些在领航计划内都有，加入领航计划，为超级个体提供一个充分发挥的舞台。</p>
    </div>
    <div>
      <h2>领航计划活动数据</h2>
      <div class="space-around activeData">
        <div>
          <img src="../../static/images/pilotProgram-02.png">
          <div>
            <div>
              <span class="font-weight" id="joinNumber">0</span><span class="littleFont">人</span>
            </div>
            <div class="littleFont">参训人数</div>
          </div>
        </div>
        <div>
          <img src="../../static/images/pilotProgram-03.png">
          <div>
            <div>
              <span class="font-weight" id="isFinishNumber">0</span><span class="littleFont">人</span>
            </div>
            <div class="littleFont">毕业人数</div>
          </div>
        </div>
        <div>
          <img src="../../static/images/pilotProgram-04.png">
          <div>
            <div>
              <span class="font-weight" id="isOrderNumber">0</span><span class="littleFont">人</span>
            </div>
            <div class="littleFont">投保人数</div>
          </div>
        </div>
        <div>
          <img src="../../static/images/pilotProgram-05.png">
          <div>
            <div>
              <span class="font-weight" id="isExcellentNumber">0</span><span class="littleFont">人</span>
            </div>
            <div class="littleFont">优秀学员</div>
          </div>
        </div>
      </div>
    </div>
    <div class="activeSearch">
      <h2>查询结业证书</h2>

      <input type="text" placeholder="请输入参训号查询证书"   v-model="search" class="search" align="" maxlength="20">
      <div id="search" @click="searchMethod">查询</div>
    </div>
    <el-dialog
      title="查看营业执照示例"
      :visible.sync="showViewer"
      width="50%"
      center>
      <div class="topTitle space-around">
        <div class="headline" data-id="1" @click="chlickBorder(1)" :class="indexShow == 1? 'border' : 'noBorder' ">
          <div style="margin:0 auto;text-align:center">结业证书</div>
        </div>
        <div class="headline" data-id="2" @click="chlickBorder(2)" :class="indexShow == 2? 'border' : 'noBorder'" >
          <div style="margin:0 auto;text-align:center">荣耀证书</div>
        </div>
        <!--<div class="headline" data-id="3">
            <div>执业认证证书</div>
        </div>-->
      </div>
      <div style="margin-top: 10px" :class="indexShow == 1 ? 'show' : 'dis'"> <el-image  :src="jieYeString"></el-image> </div>
      <div style="margin-top: 10px" :class="indexShow == 2 ? 'show' : 'dis'"> <el-image  :src="rongYuString"></el-image> </div>

      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="showViewer = false">确 定</el-button>
          </span>
    </el-dialog>

    <div class="activeSketch" style="margin-top: 50px">
    <el-carousel indicator-position="none" type="card" :height="'200px'">
      <el-carousel-item v-for="item in bannerXueList" :key="item.index" >
        <img :src="item.headimgurl" style="width: 100px;height: 100px;border-radius: 50%;">
        <div class="userInfo" style="margin-top: 5px;">
          <span>{{item.name}}</span> <span :class="item.sex == 1 ? 'swiper-lazy men' : 'swiper-lazy women' "></span>
        </div>
        <div class="littleFont">{{item.activeName}}</div>
      </el-carousel-item>
    </el-carousel>
    </div>

    <div class="activeSketch" style="margin-top: 50px">
      <h2>活动剪影</h2>

      <el-carousel indicator-position="outside"  type="card" :height= "'400px'">
        <el-carousel-item v-for="item in bannerList" :key="item.index">
            <img d :src="item.urlImg"   class="swiper-lazy" style="height:75%;">
            <div class="swiper-lazy-preloader"></div>
            <div style="margin-top: 20px">领航计划第一期</div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="cooperationPartner">
      <h2>优秀学员代表企业</h2>
      <div>
        <img src="../../static/images/pilotProgram-09.png">
        <img src="../../static/images/pilotProgram-14.png">
        <img src="../../static/images/pilotProgram-15.png">
        <img src="../../static/images/pilotProgram-16.png">
      </div>
    </div>
    <!-- 查询证书 弹窗  -->
    <div class="popup">
      <div class="certificateList">
        <div class="close"></div>
        <div class="certificateTitle">恭喜你获得了以下证书</div>
        <div class="topTitle space-around">
          <div class="headline" data-id="1" style="border-bottom: 2px solid #FF5D3B;">
            <div>结业证书</div>
          </div>
          <div class="headline" data-id="2">
            <div>荣耀证书</div>
          </div>
          <!--<div class="headline" data-id="3">
              <div>执业认证证书</div>
          </div>-->
        </div>
        <div class="contentList">
          <!--<img src="../../static/images/pilotProgram-12.png">
          <img src="../../static/images/pilotProgram-12.png">
          <img src="../../static/images/pilotProgram-12.png">-->
        </div>
      </div>
    </div>
    <!-- 活动详情 弹窗 -->
    <div class="activityPopup"></div>
</div>
  </body>
</template>
<script>
    import index from "../router";

    export default {
        name: "pilotProgram",
        data() {
            return{

                bannerList: [{"urlImg":"../../static/images/activityGraph-01.png"},{"urlImg":"../../static/images/activityGraph-02.png"},
                    {"urlImg":"../../static/images/activityGraph-03.png"} ,{"urlImg":"../../static/images/activityGraph-04.png"} ,{"urlImg":"../../static/images/activityGraph-05.png"}],
                bannerXueList: [{"urlImg":"../../static/images/pilotProgram-13.png" , "name" : "吴国福"},{"urlImg":"../../static/images/pilotProgram-13.png" , "name" : "吴国福"},
                    {"urlImg":"../../static/images/pilotProgram-13.png" , "name" : "吴国福"} ,{"urlImg":"../../static/images/pilotProgram-13.png"} ,{"urlImg":"../../static/images/pilotProgram-13.png" , "name" : "吴国福"}],
                search: "" ,
                jieYeString:"",
                rongYuString:"",
                showViewer:false,
                activeIndex: 1,
                indexShow:1
            }

        },
        methods: {
            chlickBorder(index) {
                this.indexShow = index;
            },
            handleSelect(key, keyPath) {
                this.activeIndex = key;
            },
            searchMethod(){
                this.axios.post('https://wxtestapi.xiaobaibao.com/management/userjoininfo/searchCertificate?search=' + this.search).then((response) => {
                    let data = response.data;
                    if(data.success){
                        // 根据type拆分
                        this.showViewer = true;
                        this.jieYeString = data.jieYeList[0]['certUrl'];
                        this.rongYuString = data.rongYuList[0]['certUrl'];
                    }
                });
            }

        },
        mounted() {
            this.axios.get('https://wxtestapi.xiaobaibao.com/management/userjoininfo/getPilotData').then((response) => {
                let data = response.data;
                if( data.success ){
                    // 根据type拆分
                    console.log(data.joinList );
                    this.bannerXueList = data.joinList;
                    this.$('#joinNumber').html(data.joinNumber);
                    this.$('#isFinishNumber').html(data.isFinishNumber);
                    this.$('#isExcellentNumber').html(data.isExcellentNumber);
                    this.$('#isOrderNumber').html(data.isOrderNumber);
                }
            });
        }
    }
</script>

<style scoped>
  @import "../../static/css/rcMain/swiper.min.css";
  /*@import "../../static/css/rcMain/pilotProgram.css";*/
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  .show{
    display: inline-block;

  }
  .dis{
    display: none;
  }
  .border {
     margin:0 auto;
     width:300px;
     border-bottom: 2px solid #FF5D3B;
  }
  .noBorder {
    border-bottom: 0px solid
  }

  /**
 * 领航计划PC页 css
 * @Author 吴成林
 * @Date 2020-5-20 17:14:45
 */
  html,body,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,section,summary,time,mark,audio,video {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
  }
  body {
    color: #000;
    background: #fff;
  }
  .wrapper{
    margin: 0 auto;
    padding: 78px 0 0;
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
  }

  .space-between{
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
  }
  .space-around{
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-around;
    justify-content: space-around;
  }

  .littleFont{
    color: #666666;
    font-size: 12px;
  }
  .font-weight{
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }

  /* 内容 */
  .topBackground{
    width: 100%;
    max-height: 535px;
    padding-top: 28%;
    background: url("../../static/images/pilotProgram-01.png") no-repeat center / cover;
    margin: 10px auto;
  }
  .activeTitle{
    padding: 50px 20%;
    margin-bottom: 50px;
  }
  .activeTitle h2{
    margin-bottom: 20px;
  }
  .activeTitle p{
    color: #666;
    line-height: 30px;
    letter-spacing: 1px;
  }
  .activeData{
    padding: 40px 20%;
  }
  .activeData>div>div,.activeData>div>img{
    display: inline-block;
    vertical-align: middle;
  }
  .activeData>div>img{
    width: 56px;
    height: 56px;
    margin-right: 10px;
  }

  .activeSearch{
    margin: 40px 0px 50px;
  }
  .activeSearch h2{
    margin-bottom: 30px;
  }
  .activeSearch input{
    width: 40%;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .activeSearch>div{
    width: 12%;
    background-color: #ff7052;
    padding: 10px 0px;
    color: white;
    margin: 20px auto;
    border-radius: 5px;
  }

  .memberList{
    padding: 0px 25%;
    margin: 30px 0px;
  }
  .memberList .swiper-slide>img{
    width: 75px;
    height: 75px;
    border-radius: 50%;
  }
  .memberList .swiper-slide {
    width: 25%;
    margin: 0 auto;
  }
  .userInfo>span:nth-child(1){
    font-weight: bold;
    margin: 5px 0px;
  }
  .userInfo>span{
    vertical-align: middle;
    display: inline-block;
  }
  .women{
    width: 9px;
    height: 15px;
    background: url("../../static/images/pilotProgram-08.png") no-repeat center / 100% 100%;
  }
  .men{
    width: 14px;
    height: 14px;
    background: url("../../static/images/pilotProgram-07.png") no-repeat center / 100% 100%;
  }

  .activeSketch{
    padding: 0px 20%;
    margin-bottom: 30px;
  }
  .activeSketch>h2{
    margin-bottom: 20px;
  }
  .activeSketch .swiper-slide>img{
    width:100%;
    height: 180px;
    border-radius: 4px;
  }
  .activeSketch .swiper-slide {
    width: 316px;
  }

  .cooperationPartner{
    margin: 10px auto 100px;
  }
  .cooperationPartner>h2{
    margin-bottom: 30px;
  }
  .cooperationPartner img{
    width: 175px;
    height: 157px;
  }

  /* 弹窗 */
  .popup, .activityPopup{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    background: rgba(0,0,0,.7);
    display: none;
  }
  .certificateList{
    background: white;
    width: 60%;
    height: 80%;
    position: fixed;
    top: 10%;
    left: 20%;
    padding: 20px;
    z-index: 999;
  }
  .activityPopup{
    overflow-y: scroll;
  }
  .activityPopup>img{
    max-width: 750px;
  }
  .close{
    width: 47px;
    height: 47px;
    background: url("../../static/images/pilotProgram-11.png") no-repeat center / 100% 100%;
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .certificateTitle{
    padding: 30px 0px;
    font-weight: bold;
    font-size: 18px;
  }
  .topTitle{
    width: 90%;
    height: 40px;
    line-height: 40px;
    font-Weight: bold;
    color: #333333;
    margin: 0 auto 20px;
    padding: 0px 5%;
  }
  .topTitle>div{
    width: 20%;
    margin: 0px 5%;
  }
  .contentList{
    overflow: hidden;
    overflow-y: scroll;
    padding: 20px 10%;
  }
  /*.contentList::-webkit-scrollbar{
      display: none;
  }*/
  .contentList>img{
    width: 100%;
    margin-bottom: 20px;
  }

  .emptyList{
    padding: 30% 0px;
    text-align: center;
  }
  .emptyList>img{
    width: 142px;
    height: 112px;
    margin-bottom: 10px;
  }

  /*轮播图*/
  .swiper-container {
    padding-bottom:40px;
  }
  .swiper-wrapper{
  }
  .swiper-slide {
    width:978px;
    transition-timing-function:linear;
  }
  .swiper-slide .title{
    position:absolute;
    transform:rotate(90deg);
    transform-origin:left top;
    left:-3px;
    font-size:11px;
    color: rgb(102, 102, 102);}
  .swiper-button-next, .swiper-button-prev{
    width:86px;
    height:112px;
    background-size:86px 112px;
    margin-top:-61px;
    outline:none;}
  .swiper-pagination-bullet{
    background:none;
    opacity:1;
    margin:0 6px !important;
    width:9px;
    height:9px;
    position:relative;
    outline:none;
    vertical-align:middle;}
  .swiper-pagination-bullet span{
    width:3px;
    height:3px;
    background:#CCC;
    display:block;
    border-radius:50%;
    margin-top:3px;
    margin-left:3px;
  }
  .swiper-pagination-bullet i{
    background:#000;
    height:1px;
    width:20px;
    position:absolute;
    top:4px;
    transform:scaleX(0);
    transform-origin:left;
    z-index:3;
    transition-timing-function:linear;
  }
  .swiper-pagination-bullet-active span,.swiper-pagination-bullet:hover span{
    width:9px;
    height:9px;
    margin-top:0;
    margin-left:0;
    background:#000;
    position:relative;
    z-index:1;
  }
  .swiper-pagination-bullet-active i{
    animation:middle 6s;
  }
  .swiper-pagination-bullet:first-child.swiper-pagination-bullet-active i{
    animation:first 6s;
  }
  .swiper-pagination-bullet:last-child.swiper-pagination-bullet-active i{
    animation:last 6s;
  }
  @keyframes first{
    0% {transform:scaleX(0.5);left:0px;}/*091*/
    100% {transform:scaleX(1);left:2px;} /*0915*/
  }
  @keyframes last{
    0% {transform:scaleX(0.7);left:-10px;}/*1090*/
    20% {transform:scaleX(0.3);left:2px;} /*090*/
    100% {transform:scaleX(0.3);left:0px;} /*090*/
  }
  @keyframes middle{
    0% {transform:scaleX(0.7);left:-10px;}/*1091*/
    20% {transform:scaleX(0.45);left:2px;}/*092*/
    100% {transform:scaleX(1);left:2px;} /*0913*/
  }

</style>



// WEBPACK FOOTER //
// src/components/pilotProgram.vue